import { useState } from 'react'
import * as S from './styles'

const Menu = () => {
  const [menu, setMenu] = useState(false)

  return (
    <div>
      <S.ButtonMenu onClick={() => setMenu(true)}>
        <span className="material-symbols-outlined">menu</span>
      </S.ButtonMenu>
      <S.CardMenu className={menu ? 'is-visible' : ''}>
        <S.Overlay onClick={() => setMenu(false)} />
        <S.Menu>
          <div>
            <button onClick={() => setMenu(false)}>X</button>
          </div>
          <S.Links>
            <li>
              <a href="#">Condomínios</a>
            </li>
            <li>
              <a href="#">Fórum</a>
            </li>
            <li>
              <a href="#">Guia</a>
            </li>
            <li>
              <a href="#">Artigos</a>
            </li>
            <li>
              <a href="#">Ferramentas</a>
            </li>
          </S.Links>
          <S.Links>
            <button>Cadastrar</button>
            <li>
              <a href="#">Cotar Imóvel</a>
            </li>
            <li>
              <a href="#">Planos</a>
            </li>
            <li>
              <a href="#">Entrar</a>
            </li>
          </S.Links>
        </S.Menu>
      </S.CardMenu>
    </div>
  )
}

export default Menu
